var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
var useErrorStore = create(function (set) { return ({
    error: null,
    configError: false,
    setError: function (config) {
        set(function (state) { return (__assign(__assign({}, state), config)); });
    },
    setConfigError: function (val) {
        set(function (state) { return (__assign(__assign({}, state), { configError: val })); });
    },
    resetErrorState: function () {
        set({
            error: null,
            configError: false
        });
    }
}); });
export default useErrorStore;
